export function getAspectRatio(mediaDetails) {
  let dimensions = mediaDetails
  let aspectRatio = dimensions?.width / dimensions?.height
  return aspectRatio
}
